import { render, staticRenderFns } from "./TrainingHospitals.vue?vue&type=template&id=13a7e37b&scoped=true"
import script from "./TrainingHospitals.vue?vue&type=script&lang=js"
export * from "./TrainingHospitals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a7e37b",
  null
  
)

export default component.exports